import Row from '@components/row'
import SvgImage from '@components/svg'
import TableActions from '@components/table/actions'
import theme from '@utils/theme'
import { ReactElement } from 'react'
import {
  StyleGridIconWrapper,
  StyleGridItem,
  StyleGridItems,
  StyleGridRow,
  StyleGridTitle,
  StyleGridValue,
} from './style'
import icons from '@assets/icons'
export interface IGridItem {
  title?: string
  value?: string | number
  Icon?: keyof typeof icons
  onClickEdit?: () => void
  hasAction?: boolean
  IconBg?: keyof typeof theme.colors
  tc?: any
  font?: number
}
interface IGridCard {
  items?: IGridItem[]
  customStyle?: any
  leftComponent?: ReactElement
  rightComponent?: ReactElement
}
const GridCard = ({
  items,
  customStyle,
  leftComponent,
  rightComponent,
}: IGridCard) => {
  return (
    <StyleGridItems
      customStyle={customStyle}
      cols={leftComponent || rightComponent ? items?.length + 1 : 4}
    >
      {!!leftComponent && leftComponent}
      {items?.map(({ Icon, ...resetItem }: IGridItem, index: number) => {
        return (
          <StyleGridItem key={index}>
            <StyleGridRow>
              <StyleGridRow>
                <StyleGridIconWrapper bg={resetItem?.IconBg}>
                  {!!Icon && <SvgImage src={Icon} height={20} width={20} />}
                </StyleGridIconWrapper>
                <StyleGridValue font={resetItem?.font} tc={resetItem?.tc}>
                  {resetItem?.value}
                </StyleGridValue>
              </StyleGridRow>
            </StyleGridRow>
            <Row justifyContent="space-between">
              <StyleGridTitle>{resetItem?.title}</StyleGridTitle>
              {!!resetItem?.hasAction && (
                <TableActions
                  hasEdit={true}
                  hasDelete={false}
                  hasView={false}
                  type="icon"
                  onEdit={resetItem?.onClickEdit}
                />
              )}
            </Row>
          </StyleGridItem>
        )
      })}
      {!!rightComponent && rightComponent}
    </StyleGridItems>
  )
}
export default GridCard
